import { HeadCell, ACTION } from '../../../component/table/interfaces/TableInterface';

export const HEAD_CELL: Array<HeadCell> = [
  { id: 'MATNR', label: 'Material' },
  { id: 'EAN11', label: 'Código EAN' },
  { id: 'MAKTX', label: 'Descrição' },
  { id: 'VIGENTE', label: 'Preço (R$)', format: ['monetary'], align: 'right' },
  { id: 'ESTOQUE', label: 'Estoque', align: 'center' },
  { id: ACTION, label: 'Ação' }
];
